/** Platform-wide runtime settings (admin-only). */
import { apiGet, apiPost, apiPut } from '../client.js';
import type { SettingField, SettingReveal, TaskConcurrencySetting } from '../types.js';

export function getTaskConcurrencySetting(): Promise<TaskConcurrencySetting> {
  return apiGet<TaskConcurrencySetting>('/api/v1/admin/platform-settings/task-concurrency');
}

/** The body is the whole section: a null clears that value. */
export function setTaskConcurrencySetting(values: {
  global_max_concurrent_tasks: number | null;
  org_default_max_concurrent_tasks: number | null;
}): Promise<TaskConcurrencySetting> {
  return apiPut<TaskConcurrencySetting>(
    '/api/v1/admin/platform-settings/task-concurrency',
    values,
  );
}

export function listSettingFields(): Promise<SettingField[]> {
  return apiGet<SettingField[]>('/api/v1/admin/platform-settings/fields');
}

export function updateSettingField(
  key: string,
  value: unknown | null,
): Promise<SettingField[]> {
  return apiPut<SettingField[]>(`/api/v1/admin/platform-settings/fields/${key}`, { value });
}

export function revealSettingField(key: string): Promise<SettingReveal> {
  return apiPost<SettingReveal>(`/api/v1/admin/platform-settings/fields/${key}/reveal`);
}
